import map from 'lodash/fp/map'
import over from 'lodash/fp/over'
import pipe from 'lodash/fp/pipe'
import unnest from 'lodash/fp/unnest'
import zip from 'lodash/fp/zip'
import zipAll from 'lodash/fp/zipAll'
import * as Redux from 'redux'
import * as Elasticsearch from '../../../elasticsearch'
import * as Request from '../../../request'
import * as Constants from './constants'
import * as Types from './types'

export type WrappedState = Types.WrappedState
const viewReducer = (state = {isLoading: false}, action: Request.ResponseAction) => {
  switch (action.type) {
    case Request.requestConstant(Constants.FETCH_KNOWLEDGE_TIERS):
      return {isLoading: true}
    case Request.successConstant(Constants.FETCH_KNOWLEDGE_TIERS):
    case Request.errorConstant(Constants.FETCH_KNOWLEDGE_TIERS):
      return {isLoading: false}
    default:
      return state
  }
}

const EMPTY_TIER = {
  memberCount: 0,
  totalClickCount: 0,
  totalDeliveryCount: 0,
  totalOpenCount: 0,
  uniqueClickCount: 0,
  uniqueDeliveryCount: 0,
  uniqueOpenCount: 0,
}
const EMPTY_TIERS = [
  {tier: 'A', ...EMPTY_TIER},
  {tier: 'B', ...EMPTY_TIER},
  {tier: 'C', ...EMPTY_TIER},
  {tier: 'D', ...EMPTY_TIER},
  {tier: 'E', ...EMPTY_TIER},
  {tier: 'F', ...EMPTY_TIER},
  {tier: 'G', ...EMPTY_TIER},
  {tier: 'H', ...EMPTY_TIER},
  {tier: 'I', ...EMPTY_TIER},
]
export const collectCounts: any = pipe(
  over([
    pipe(
      Elasticsearch.createAggSelector(Elasticsearch.AggFieldNames.UniqueTagCount),
      map(
        over([
          Elasticsearch.selectValueAgg(Elasticsearch.AggFieldNames.DeliveryCount),
          Elasticsearch.selectValueAgg(Elasticsearch.AggFieldNames.UniqueClickCount),
          Elasticsearch.selectValueAgg(Elasticsearch.AggFieldNames.UniqueOpenCount),
          Elasticsearch.selectValueAgg(Elasticsearch.AggFieldNames.UniqueCount),
          Elasticsearch.selectValueAgg(Elasticsearch.AggFieldNames.TotalClickCount),
          Elasticsearch.selectValueAgg(Elasticsearch.AggFieldNames.TotalOpenCount),
        ]),
      ),
    ),
  ]),
  zipAll,
  map(unnest),
  map(([
    deliveryCount,
    uniqueClickCount,
    uniqueOpenCount,
    memberCount,
    totalClickCount,
    totalOpenCount,
  ]) => ({
    deliveryCount,
    memberCount,
    totalClickCount,
    totalOpenCount,
    uniqueClickCount,
    uniqueOpenCount,
  })),
  zip(EMPTY_TIERS),
  map(([emptyTier, responseTier]) => ({...emptyTier, ...responseTier})),
)

export const selectEngagement: any = pipe(
  collectCounts,
  map(({
    tier,
    totalClickCount,
    totalOpenCount,
    uniqueClickCount,
    deliveryCount,
    uniqueOpenCount,
  }) => ({
    tier,
    totalClickRate: Elasticsearch.asPercentage((totalClickCount / deliveryCount) || 0),
    totalOpenRate: Elasticsearch.asPercentage((totalOpenCount / deliveryCount) || 0),
    uniqueClickRate: Elasticsearch.asPercentage((uniqueClickCount / deliveryCount) || 0),
    uniqueOpenRate: Elasticsearch.asPercentage((uniqueOpenCount / deliveryCount) || 0),
  })),
)
export const knowledgeTierEngagement: Redux.Reducer<Types.TierRates[]> = (state = [], action) => {
  switch (action.type) {
    case Request.successConstant(Constants.FETCH_KNOWLEDGE_TIERS):
      return selectEngagement(action.payload.response)
    default:
      return state
  }
}

export const knowledgeTierCount: Redux.Reducer<Types.TierCounts[]> = (state = [], action) => {
  switch (action.type) {
    case Request.successConstant(Constants.FETCH_KNOWLEDGE_TIERS):
      return collectCounts(action.payload.response)
    default:
      return state
  }
}

export const reducer = Redux.combineReducers({
  knowledgeTierCount,
  knowledgeTierEngagement,
  view: viewReducer,
})



// WEBPACK FOOTER //
// ./src/pages/reports/knowledge-tiers/reducer.ts